var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75h6.75V1.5H1.5v5.25zM3 3h3.75v2.25H3V3zM1.5 14.25h6.75V9H1.5v5.25zM3 10.5h3.75v2.25H3V10.5zM1.5 21.75h6.75V16.5H1.5v5.25zM3 18h3.75v2.25H3V18zM20.25 6.75H13.5l2.558-2.692L15 3l-4.5 4.5L15 12l1.058-1.057L13.5 8.25h6.75A.75.75 0 0121 9v9a.75.75 0 01-.75.75h-9v1.5h9A2.25 2.25 0 0022.5 18V9a2.25 2.25 0 00-2.25-2.25z",
    fill: "#45464F"
  })));
}
export default SvgInsert;